import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    deliverablesList: [],
    totalPages: 0,
    page: 0,
    size: 0,
    total: 0,
    loaderForButton: false,
    dataLoader: false,
}

const deliverablesSlice = createSlice({
    name: 'deliverables',
    initialState,
    reducers: {
        setDeliverablesList(state, action) {
            state.deliverablesList = action?.payload?.pagination ? [...state?.deliverablesList,...action?.payload?.deliverablesList ]: action?.payload?.deliverablesList;
            state.page = action?.payload?.page||0;
            state.size = action?.payload?.size||0;
            state.total = action?.payload?.total;
            state.dataLoader= action.payload.dataLoader || false;
            state.loaderForButton=action?.payload?.loaderForButton||false;
            state.totalPages = action?.payload?.totalPages;
        },
        setLoaderForButton(state,action){
            state.loaderForButton = action?.payload;
        },
        setDataLoader(state, action) {
            state.dataLoader = action?.payload;
        },
        clearDeliverablesList(state, action) {
            return initialState;
        }
    }
})

export const {clearDeliverablesList,setDataLoader,setLoaderForButton,setDeliverablesList}= deliverablesSlice.actions
export const deliverableActions = deliverablesSlice.actions;

export default deliverablesSlice;